module.exports = __webpack_public_path__ + "img/background-lite.321b8a9b.png";